import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchExchangeRate } from "../redux/guest-slices/common.slice";
import { getLocalPrice, formatLocalPrice } from "../utils/helper";

/**
 * Custom React hook to retrieve the current exchange rate from the database.
 * Automatically triggers the API fetch if not already loaded in the Redux store.
 * Returns the rate and helper functions to convert and format prices based on the user's timezone.
 */
export function useExchangeRate() {
  const dispatch = useDispatch();
  const { exchangeRate } = useSelector((state) => state.otherSlice);

  useEffect(() => {
    if (!exchangeRate) {
      dispatch(fetchExchangeRate());
    }
  }, [dispatch, exchangeRate]);

  const rate = exchangeRate?.rate || 1;
  console.log({ rate, exchangeRate });

  const convert = (usdPrice, currency = "usd") => {
    return getLocalPrice(usdPrice, rate, currency);
  };

  const format = (usdPrice, currency = "usd") => {
    return formatLocalPrice(usdPrice, rate, currency);
  };

  return {
    rate,
    convert,
    format,
  };
}

export default useExchangeRate;
